import { ReactElement } from 'react';
import { Address } from 'viem';

import { useTranslation } from 'modules/i18n';

import { DelegateRow } from '../DelegateRow';
import { StakingTable as Table } from '../StakingTable';
import { translation } from './translation';

interface DelegateStakingTableProps {
  poolAddresses: Address[];
}

export function DelegateStakingTable({
  poolAddresses,
}: DelegateStakingTableProps): ReactElement {
  const { keys, t } = useTranslation(translation);

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>{t(keys.poolName)}</Table.HeadCell>

          <Table.HeadCell>{t(keys.apy)}</Table.HeadCell>

          <Table.HeadCell>{t(keys.myPosition)}</Table.HeadCell>

          <Table.HeadCell align="right">{t(keys.actions)}</Table.HeadCell>
        </Table.Row>
      </Table.Head>

      <Table.Body>
        {poolAddresses.map(address => (
          <DelegateRow key={address} poolAddress={address} />
        ))}
      </Table.Body>
    </Table>
  );
}
